import React from 'react';
import { Link } from 'react-router-dom';
//style
import 'bootstrap/dist/css/bootstrap.css';
import './signupbutton.styl'

class SignupButton extends React.Component {
  constructor(props){
  	super(props);

  	this.state = {
  		hidden: 'visible'
  	}
  }

  componentWillMount = () => {
  	const name = localStorage.getItem('name');
  	if(name)
  	  this.setState({ hidden: 'hidden' });
  	else
  	  this.setState({ hidden: 'visible' });
  }

  componentWillReceiveProps = () => {
  	const name = localStorage.getItem('name');
  	if(name)
  	  this.setState({ hidden: 'hidden' });
  	else
  	  this.setState({ hidden: 'visible' });
  }

  render(){
    return (
      <Link to='/signup/' className={'btn btn-default signup-button toggle '+this.state.hidden}>Sign up now</Link>
    );
  }
}

export default SignupButton;



// WEBPACK FOOTER //
// ./src/components/signupbutton/SignupButton.js